module.exports = {
  id: 'attachments',
  type: 'attachments',
  icon: 'paperclip',
  title: 'ProjectDetails.attachments',
  classes: {
    attachment: {
    },
  }
};
